import React from "react";
import { Box, Button, Text } from "grommet";
import useToc from "../hooks/useToc";
import { List, More, MoreVertical, Table } from "grommet-icons";
import { BsChevronContract, BsChevronExpand } from "react-icons/bs";
import TocRecordsdBox from "./TocRecordsBox";

const BookTocModal = (props: any) => {
    const [received, setReceived] = React.useState(false);
    const [tocs, setTocs] = React.useState<any>([]);
    const [ready, setReady] = React.useState(false);
    const [firstOpen, setFirstOpen] = React.useState(0);

    let sHeight = window.innerHeight;
    const [height, setHeight] = React.useState(sHeight);

    React.useEffect(() => {
        setHeight(sHeight);
        console.log("sHeight", sHeight);
    }, [sHeight]);

    let book = props.bookinfo;

    React.useEffect(() => {
        const receiveData = async () => {
            const res = await useToc.getTocsByBookId(book.book_id);
            // console.log("received tocs", res);
            //   add toc_sort_no

            //  make toc_dict key : toc_id, value : toc_sort_no
            let toc_dict:any = {}

            res.tocs.forEach((t: any) => {
                t.toc_sort_no = t.toc_id.toString() + ".";
                if (t.toc_upper !== null) {
                    let toc_pre = ""
                    // check exist in toc_dict
                    if (t.toc_upper in toc_dict) {
                        toc_pre = toc_dict[t.toc_upper]
                    } else {
                        toc_pre = t.toc_upper + "."
                    }
                    t.toc_sort_no = toc_pre + t.toc_id + ".";
                }
                toc_dict[t.toc_id] = t.toc_sort_no
            });
            // console.log("add sort_no", res.tocs);

            setTocs(res.tocs);
            setReceived(true);
        };
        receiveData();
    }, []);

    React.useEffect(() => {
        // console.log("test-received", received, tocs);
        if (received && tocs.length > 0) {

            // sort tocs by toc_sort_no alphabetically
            tocs.sort((a: any, b: any) => {
                return a.toc_sort_no> b.toc_sort_no? 1: -1
            });


            // tocs.sort((a: any, b: any) => {
            //     return a.toc_sort_no.localeCompare(b.toc_sort_no);
            // });



            // tocs.sort((a: any, b: any) => {
            //     return a.toc_sort_no - b.toc_sort_no;
            // });
            console.log("sorted_tocs", tocs);

            // first index toc with tocrecord_count>0
            let first_index = 0;
            for (let i = 0; i < tocs.length; i++) {
                if (tocs[i].toc_record_count > 0) {
                    first_index = i;
                    break;
                }
            }
            setFirstOpen(first_index);
            setReady(true);
        }
    }, [received, tocs]);

    // console.log("BookToc", tocs);

    const BookInfo = () => {
        return (
            <Box alignSelf="center">
                <Text>
                    <Text size="18px" margin={{ right: "5px" }} weight="bold">
                        {book.book_title}.
                    </Text>
                    <Text size="18px" margin={{ right: "5px" }}>
                        {book.numeration}.
                    </Text>
                    <Text size="15px" margin={{ right: "5px" }}>
                        {<Publisher publisher={book.publisher} />}.
                    </Text>
                    <Text size="15px" margin={{ right: "5px" }}>
                        {book.publish_date}.
                    </Text>
                </Text>
            </Box>
        );
    };
    const Publisher = (props: any) => {
        const { publisher } = props;
        let title_div = publisher.split("<");
        let title = title_div[0];
        let title_info = "";
        if (title_div.length > 1) {
            title_info = title_div[1].replace(">", "");
        }
        return (
            <>
                <Text size="12px" margin="1px">
                    {" "}
                    {title}
                </Text>
                {title_info !== "" && (
                    <Text margin={{ left: "5px" }} size="12px" color="grey">
                        {title_info}
                    </Text>
                )}
            </>
        );
    };
    const TocTitle = (props: any) => {
        const [title, setTitle] = React.useState(props.title);
        const [tocN, setTocN] = React.useState(0);

        React.useEffect(() => {
            let t = props.title;
            t = t.replaceAll("ㅁ", "");
            t = t.replaceAll("/ㅁ", "/");
            t = t.replaceAll("/", " / ");
            setTitle(t);
            let N = t.split("/").length;
            setTocN(N);
        }, []);

        return (
            <Text>
                {title.split("/").map((t: any, index: number) => {
                    return (
                        <Text
                            key={index}
                            size={index === tocN - 1 ? "13px" : "11px"}
                            color={index === tocN - 1 ? "black" : "grey"}
                            margin={{ right: "5px" }}
                        >
                            {t}
                        </Text>
                    );
                })}
            </Text>
        );
    };

    const TocInfo = (props: any) => {
        let toc = props.toc;
        const openRecord = props.recordOpen;
        const [recordOpen, setRecordOpen] = React.useState(false);

        React.useEffect(() => {
            setRecordOpen(openRecord);
        }, []);

        const RecordInfo = (props: any) => {
            return (
                <Box
                    direction="column"
                    height="full"
                    margin={{ horizontal: "10px" }}
                    width="98%"
                    flex={false}
                >
                    <Box direction="row" align="center" justify="end">
                        <Text
                            size="10px"
                            color="green"
                            margin={{ left: "5px" }}
                        >
                            {toc.toc_record_count}
                        </Text>
                        <Button
                            plain
                            margin={{ horizontal: "5px" }}
                            onClick={() => setRecordOpen(!recordOpen)}
                            hoverIndicator={true}
                            icon={
                                recordOpen ? (
                                    <BsChevronContract size="12px" />
                                ) : (
                                    <BsChevronExpand size="12px" />
                                )
                            }
                        />
                    </Box>
                    {recordOpen && (
                        <Box
                            align="center"
                            width="full"
                            flex={false}
                            margin="5px"
                            pad="10px"
                        >
                            <TocRecordsdBox tocinfo={toc}/>
                        </Box>
                    )}
                </Box>
            );
        };
        return (
            <Box
                width="full"
                pad="10px"
                margin="3px"
                direction="column"
                align="start"
                justify="between"
                style={{ minWidth: "400px" }}
                background="rgba(100,100,100,0.1)"
                flex={false}
            >
                <Box width="full" pad={{ horizontal: "10px" }}>
                    <TocTitle title={toc.toc_title} toc_h={toc.toc_hierarchy} />
                </Box>

                <Box
                    pad="5px"
                    direction="row"
                    align="start"
                    justify="start"
                    width="full"
                >
                    {toc.tableau_count > 0 ? (
                        <Box direction="row" align="end" justify="end" alignSelf="end" width='full'>
                            <Table size="13px" color="green" />
                            <Text
                                size="13px"
                                color="green"
                                margin={{ left: "5px" }}
                            >
                                {toc.tableau_count}
                            </Text>
                        </Box>
                    ) : (
                        <></>
                    )}
                    {toc.toc_record_count > 0 ? <RecordInfo /> : <></>}
                </Box>
            </Box>
        );
    };

    const columns_hide = [
        "number",
        "book_category",
        "numeration",
        "pub_date",
        "publisher",
        "book_title",
        "toc_title",
        "toc_id",
        "person_id",
        "school_id",
        "school_name",
        "pname",
    ];

    return (
        <Box
            width="full"
            height="full"
            background="white"
            pad="20px"
            direction="column"
            alignSelf="center"
        >
            <Box width="full" pad="10px" align="center" justify="center">
                <BookInfo />
            </Box>
            <Box
                width="full"
                height={(height - 200).toString() + "px"}
                pad="30px"
                align="start"
                justify="start"
                direction="column"
                overflow={"auto"}
                flex={false}
            >
                {ready && (
                    <>
                        {tocs.map((toc: any, index: number) => {
                            return <TocInfo key={index} toc={toc}
                            recordOpen={index===firstOpen? true: false} />;
                        })}
                    </>
                )}
            </Box>
        </Box>
    );
};

export default BookTocModal;
